import axios from "axios";

export const DRIVER_TOKEN_KEY = "cr_driver_token";

export const driverApi = axios.create({ baseURL: `${process.env.REACT_APP_BACKEND_URL}/api` });

driverApi.interceptors.request.use((cfg) => {
  const t = localStorage.getItem(DRIVER_TOKEN_KEY);
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});
